import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import { initialize } from "./actions"

import Contracts from "./components/Contracts"
import { IOldUIContext, IOldUIInit } from "../../global"

function init(store: AppStore, oldUIContext: IOldUIContext): IOldUIInit {
    const start = (): void => {
        const element = document.getElementById("newui-deployment-contracts")
        if (!element) {
            return
        }
        store.dispatch(initialize())

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <OldUIContext.Consumer>
                        {(): JSX.Element => <Contracts />}
                    </OldUIContext.Consumer>
                </OldUIContext.Provider>
            </Provider>,
        )
    }
    return {
        start,
    }
}

export default init
